export default class memberapplicationAddress extends HTMLDivElement {

    constructor() {
        super();
    }

    get sparLookup() {
        return document.querySelector("[is='spar-lookup'");
    }
    get formContainer() {
        return this.querySelector("[data-memberapplication-address='form']");
    }
    get togglerContainer() {
        return this.querySelector("[data-memberapplication-address='toggler']");
    }
    get maskedContentArea() {
        return this.querySelector("[data-spar-lookup='maskedContent']");
    }
    get maskedContact() {
        return this.querySelector("[data-spar-lookup='maskedContact']");
    }
    get maskedAddress() {
        return this.querySelector("[data-spar-lookup='maskedAddress']");
    }
    get maskedPostalAddress() {
        return this.querySelector("[data-spar-lookup='maskedPostalAddress']");
    }
    get toggler() {
        return this.togglerContainer.querySelector("input[type='checkbox']");
    }

    displayMaskedContent(data) {
        this.maskedContact.innerHTML = data.Fullname;
        this.maskedAddress.innerHTML = data.Address;
        this.maskedPostalAddress.innerHTML = data.PostalAddress;
        this.maskedContentArea.classList.remove("hidden");
    }

    showMaskedContent() {
        this.maskedContentArea.classList.remove("hidden");
        this.togglerContainer.classList.remove("hidden");
        if (this.toggler.checked) {
            this.formContainer.classList.remove("hidden");
        } else {
            this.formContainer.classList.add("hidden");
        }
    }

    hideMaskedContent() {
        this.maskedContentArea.classList.add("hidden");
    }

    displayAddress() {
        this.toggler.setAttribute("aria-expanded", "true");
        this.formContainer.classList.remove("hidden");
    }

    hideAddress() {
        this.toggler.setAttribute("aria-expanded", "false");
        this.formContainer.classList.add("hidden")
    }

    toggleAddressForm(e) {
        if (e.srcElement.checked) {
            this.displayAddress();
        }
        else {
            this.hideAddress();
        }
    }

    sparLookupCompletedHandler(e) {

        if (e.detail.Successful === true) {
            this.togglerContainer.classList.remove("hidden")
            if (e.detail.ShowData) {
                this.showMaskedContent();
                this.displayMaskedContent(e.detail.data);
            }
        } else {
            this.hideMaskedContent();
            this.togglerContainer.classList.add("hidden")
            this.formContainer.classList.remove("hidden")
        }
    }

    connectedCallback() {

        this.toggler.setAttribute("aria-expanded", "false");

        this.toggler.addEventListener('change', this.toggleAddressForm.bind(this));

        // MR: This doesn't seem to work
        if (this.sparLookup.disabled) {
            this.showMaskedContent();
        } else {
            this.hideMaskedContent();
        }

        this.sparLookup.addEventListener('sparLookupCompleted', this.sparLookupCompletedHandler.bind(this));

        document.querySelector("[is='spar-lookup']").addEventListener('sparLookupReset',
            e => {
                this.toggler.checked = false;
                this.togglerContainer.classList.add("hidden");
                this.formContainer.classList.add("hidden");
            });
    }

    disconnectedCallback() {
        document.querySelector("[is='spar-lookup'").removeEventListener()('sparLookupCompleted');
    }

}

customElements.define('memberapplication-address', memberapplicationAddress, { extends: "div" });